"use client";
/*eslint-disable */
import React, { useState } from "react";
import FsLightbox from "fslightbox-react";

const TestimonioVideoComponent: React.FC = () => {
  // if toggler is updated when lightbox is closed it will open it
  // if toggler is updated when lightbox is opened it will close it
  const [toggler, setToggler] = useState(false);
  return (
    <>
      <FsLightbox
        toggler={toggler}
        sources={["https://youtu.be/ElTJ6ksxpuI"]}
      />

      <div className="funfacts-area bg-FFB657 pt-100 mb-100">
        <div className="container">
          {/* <div className="section-title">
            <h2 className="nunito-font">
              Flexible study at your own pace to your own needs
            </h2>
          </div> */}

          <div
            className="video-box"
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-once="true"
            data-aos-delay="300"
          >
            <img
              src="/images/plantilla-videos.webp"
              alt="video"
              width={1100}
              height={658}
            />
            <div
              onClick={() => setToggler(!toggler)}
              className="video-btn popup-youtube"
            >
              <i className="flaticon-play"></i>
            </div>

            <div className="shape15">
              <img
                src="/images/shape/shape15.png"
                alt="shape"
                width={159}
                height={170}
              />
            </div>
            {/* <div className="shape16">
              <img
                src="/images/shape/shape16.png"
                alt="shape"
                width={207}
                height={203}
              />
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default TestimonioVideoComponent;
